import Vue from 'vue';
import { DecoratedClass } from 'vue-class-component/lib/declarations';

export const VueInject = (injectClass: string, injectNamed: string|null = null) => {
    return function (target: Vue | typeof Vue, key: string) {
        const Ctor = typeof target === 'function'
            ? target as DecoratedClass
            : target.constructor as DecoratedClass;
        if (!Ctor.__decorators__) {
            Ctor.__decorators__ = []
        }

        Ctor.__decorators__.push(options => {
            if (options.computed == null)
                options.computed = {};

            options.computed[key] = function () {
                let _this = <{resolveService: (x: any, y: any) => any}> this;
                return _this.resolveService(injectClass, injectNamed);
            }
        });
    }
};